module.exports = __webpack_public_path__ + "img/404.a7c2f319.png";